// Token storage — local dev only.
// In production, auth is managed by the HttpOnly session cookie set by the backend.
// getToken() always returns null in production; the cookie is sent automatically.

import { createStorage, type SafeStorage } from '../storage';
import { AUTH_STORAGE_KEYS } from './keys';

// Lazy storage handle — createStorage probes the underlying Storage object,
// so calling it at module-load time would freeze the wrong reference in test
// environments that stub localStorage per test.
let cachedStorage: SafeStorage | null = null;
function getStorage(): SafeStorage {
  if (cachedStorage === null) {
    cachedStorage = createStorage('local');
  }
  return cachedStorage;
}

// Test-only: drops the cached storage handle so a freshly stubbed
// localStorage will be picked up on the next call.
export function __resetTokenStorageForTests(): void {
  cachedStorage = null;
}

export function getToken(): string | null {
  // Local dev only: returns the dev token stored by fetchTestToken().
  // In production: returns null — session cookie handles auth automatically.
  if (!import.meta.env.DEV) return null;
  const value = getStorage().get<string | null>(AUTH_STORAGE_KEYS.token, null);
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function setToken(token: string): void {
  getStorage().set(AUTH_STORAGE_KEYS.token, token);
}

export function clearToken(): void {
  getStorage().remove(AUTH_STORAGE_KEYS.token);
}
